module.exports = __webpack_public_path__ + "static/media/YM82_5.b205c9b9.jpg";